import React, { useContext } from 'react';

import { app } from 'context';
import { Layout, Text } from 'ds';

import { MARQUEE_LOGOS } from './homeV10Constants';

const MarqueeLogo: React.FC<{ label: string; variant: 'default' | 'italic' | 'mono' | 'thin' }> = ({
  label,
  variant
}) => {
  const cls =
    variant === 'italic'
      ? 'HomeV10-marqLogo HomeV10-marqLogoItalic'
      : variant === 'mono'
        ? 'HomeV10-marqLogo HomeV10-marqLogoMono'
        : variant === 'thin'
          ? 'HomeV10-marqLogo HomeV10-marqLogoThin'
          : 'HomeV10-marqLogo';

  if (label === 'FurtherAI') {
    return (
      <Layout flex align="center" gap={0} className={cls}>
        <Text
          inline
          size="headline-sm"
          color="gray-600"
          semibold
          __style={{ fontWeight: 700, letterSpacing: '-0.025em' }}
        >
          Further
        </Text>
        <Text inline size="headline-sm" color="gray-600" semibold __style={{ fontWeight: 800 }}>
          AI
        </Text>
      </Layout>
    );
  }

  return <span className={cls}>{label}</span>;
};

const HomeMarqueeSection: React.FC = () => {
  const { contentPaddingX } = useContext(app);
  const doubled = [...MARQUEE_LOGOS, ...MARQUEE_LOGOS];

  return (
    <Layout color="white" paddingY={36} paddingX={contentPaddingX} borderBottom borderColor="gray-50" borderWidth={1}>
      <Layout justify="center" flex>
        <Layout maxWidth={1280} flexGrow={1}>
          <div className="HomeV10-marqueeMask">
            <div className="HomeV10-marqueeTrack">
              {doubled.map((item, i) => (
                <MarqueeLogo key={`${item.label}-${i}`} label={item.label} variant={item.variant} />
              ))}
            </div>
          </div>
          <Layout justify="center" align="center" marginTop={32}>
            <Text size="body-md" color="gray-500" align="center" __style={{ lineHeight: 1.5, fontWeight: 400 }}>
              Trusted by ops and people teams at fast-growing companies
            </Text>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default HomeMarqueeSection;
